<template>
  <div>
    <template v-if="isProcessingWithoutPay">
      <div v-if="!isDueProcess" class="flex items-start lg:items-center justify-end">
        <div class="text-right px-4 py-3 sm:px-6">
          <span class="inline-flex">
            <router-link class="btn btn-secondary mr-4" to="/">{{ $t('Close') }}</router-link>
            <button class="btn btn-green" @click.prevent="saveWithoutPay">
              {{ $t('Save') }}
            </button>
          </span>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="container my-2">
        <template v-if="$store.state.settings.is_demo_mode">
          <demo-note></demo-note>
        </template>
        <select class="w-full form-input bg-blue-50 shadow" v-model="payment_gateway_step">
          <option :value="null" disabled>
            {{ $t('Select an option to make payment') }}
          </option>
          <option v-if="canProcessCOD" value="cod">{{ $t('Cash on delivery') }}</option>
          <option v-if="canProcessBraintree" value="braintree">{{ $t('Card Payment') }} <small>(braintree)</small></option>
          <option v-if="canProcessStripe" value="stripe">{{ $t('Card Payment') }} <small>(stripe)</small></option>
          <option v-if="canProcessSqaure" value="square">{{ $t('Card Payment') }} <small>(square)</small></option>
          <option v-if="canProcessTwoCO" value="twoCO">{{ $t('Card Payment') }} <small>(2 checkout)</small></option>
        </select>
        <div class="bg-blue-50 shadow rounded-md lg:mt-2 lg:mx-auto lg:max-w-3xl">
          <template v-if="canProcessTwoCO">
            <div v-show="payment_gateway_step === 'twoCO'">
              <form type="post" id="payment-form-2co">
                <div class="input-wrapper">
                  <label for="name" class="label control-label">Name</label>
                  <input type="text" id="card_name" class="field form-control" />
                </div>
                <div id="card-element-2co">
                  <!-- A TCO IFRAME will be inserted here. -->
                </div>
                <button id="card-button" type="submit" class="btn btn-blue">
                  {{ $t('Pay') }}
                </button>
              </form>
            </div>
          </template>

          <template v-if="canProcessCOD">
            <div v-show="payment_gateway_step === 'cod'">
              <div class="p-5">
                <button @click.prevent="codProcess" class="btn btn-blue">
                  {{ $t('Submit Request') }}
                </button>
              </div>
            </div>
          </template>
          <template v-if="canProcessBraintree">
            <div v-show="payment_gateway_step === 'braintree'">
              <div class="px-5">
                <template v-if="isAllowPayPalProcessing">
                  <v-braintree
                    :authorization="clientToken"
                    :paypal="{ flow: 'vault' }"
                    :btnText="$t('Pay')"
                    @error="braintreeError"
                    @success="braintreeProcess"
                    btnClass="btn btn-green"
                  ></v-braintree>
                </template>
                <template v-else>
                  <v-braintree
                    :authorization="clientToken"
                    :btnText="$t('Pay')"
                    @error="braintreeError"
                    @success="braintreeProcess"
                    btnClass="btn btn-green"
                  ></v-braintree>
                  <br />
                </template>
              </div>
            </div>
          </template>
          <template v-if="canProcessStripe">
            <div v-show="payment_gateway_step === 'stripe'">
              <div class="p-5">
                <stripe-element-card ref="elementRef" :pk="stripePulishableKey" @token="tokenCreated" @error="stripeError" :loading="true" />
                <button class="btn btn-green" @click.prevent="stripeProcess">
                  {{ $t('Pay') }}
                </button>
              </div>
            </div>
          </template>
          <template v-if="canProcessSqaure">
            <div v-show="payment_gateway_step === 'square'" class="p-5">
              <div id="card-container-sq" class="pb-0"></div>
              <button id="card-button-sq" type="button" class="btn btn-green">
                {{ $t('Pay') }}
              </button>
            </div>
          </template>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { StripeElementCard } from '@vue-stripe/vue-stripe';
import DemoNote from '@/components/payments/demo-note';

export default {
  name: 'gateways',
  components: {
    StripeElementCard,
    'demo-note': DemoNote,
  },
  data() {
    return {
      payment_gateway_step: null,
      gateway: {
        key: null,
        value: null,
      },
    };
  },
  props: {
    isDueProcess: { type: Boolean, default: false },
  },
  mounted() {
    const _this = this;
    this.payment_gateway_step = this.$store.state.settings.default_gateway;
    if (this.isDueProcess && this.$store.state.settings.default_gateway == 'cod') {
      this.payment_gateway_step = null;
    }
    /*-------2CO-------*/
    if (this.$store.state.settings.twoCO_state) {
      // Initialize the 2Pay.js client.
      let jsPaymentClient = new TwoPayClient('AVLRNG');

      // Create the component that will hold the card fields.
      let component = jsPaymentClient.components.create('card');

      // Mount the card fields component in the desired HTML tag. This is where the iframe will be located.
      component.mount('#card-element-2co');

      // Handle form submission.
      document.getElementById('payment-form-2co').addEventListener('submit', (event) => {
        event.preventDefault();

        // Extract the Name field value
        const billingDetails = {
          name: document.querySelector('#card_name').value,
          cardHolderName: document.querySelector('#card_name').value,
        };

        // Call the generate method using the component as the first parameter
        // and the billing details as the second one
        jsPaymentClient.tokens
          .generate(component, billingDetails)
          .then((response) => {
            _this.processWithTwoCheckout(response.token);
          })
          .catch((error) => {
            console.error(error);
          });
      });
    }
    /*......square payment......*/
    if (this.$store.state.settings.square_state) {
      this.main();
    }
    /*--------square end-----------*/
  },
  computed: {
    canProcessTwoCO() {
      return false;
    },
    stripePulishableKey() {
      return this.$store.state.settings.stripe_pk;
    },
    isProcessingWithoutPay() {
      return this.$store.state.settings.is_processing_without_pay;
    },
    isAllowPayPalProcessing() {
      return window.app.braintree_with_paypal;
    },
    canProcessBraintree() {
      return this.$store.state.settings.braintree_state && window.app.braintree_client_token;
    },
    canProcessCOD() {
      if (this.isDueProcess) {
        return false;
      } else {
        return this.$store.state.settings.cod_state;
      }
    },
    canProcessStripe() {
      return this.$store.state.settings.stripe_state;
    },
    canProcessSqaure() {
      return this.$store.state.settings.square_state;
    },
    clientToken() {
      return window.app.braintree_client_token;
    },
  },
  methods: {
    async main() {
      const _this = this;
      const appId = this.$store.state.settings.square_application_id;
      const locationId = this.$store.state.settings.square_location_id;
      const payments = Square.payments(appId, locationId);
      const card = await payments.card();
      await card.attach('#card-container-sq');

      async function eventHandler(event) {
        event.preventDefault();
        try {
          const result = await card.tokenize();
          if (result.status === 'OK') {
            _this.processWithSquare(result.token);
          }
        } catch (e) {
          console.error(e);
        }
      }
      const cardButton = document.getElementById('card-button-sq');
      cardButton.addEventListener('click', eventHandler);
    },

    submit() {
      this.$emit('start');
      this.$emit('process', this.gateway);
    },
    /*stripe processing*/
    tokenCreated(token) {
      this.gateway.key = 'stripe_token';
      this.gateway.value = token.id;
      this.submit();
    },
    stripeProcess() {
      this.$emit('start');
      this.$refs.elementRef.submit();
    },
    stripeError() {
      this.$emit('stop');
    },

    /*braintree processing*/
    braintreeProcess(payload) {
      this.gateway.key = 'braintree_nonce';
      this.gateway.value = payload.nonce;
      this.submit();
    },
    braintreeError(error) {
      this.$emit('stop');
      this.$notify({
        title: this.$i18n.t('Something went wrong try again !').toString(),
        text: error.message.toString(),
        type: 'error',
      });
    },
    /*without payment*/
    saveWithoutPay() {
      this.gateway.key = 'biller';
      this.gateway.value = this.$i18n.t('Created without processing payment');
      this.submit();
    },
    /*cash on delivery*/
    codProcess() {
      if (!this.isDueProcess) {
        this.gateway.value = true;
        this.gateway.key = 'cod_process';
        this.submit();
      }
    },
    /*2co*/
    processWithTwoCheckout(body) {
      this.gateway.key = '2_checkout_pay_nonce';
      this.gateway.value = body;
      this.submit();
    },
    /*square processing*/
    processWithSquare(body) {
      this.gateway.key = 'square_source_id';
      this.gateway.value = body;
      this.submit();
    },
  },
};
</script>
